import { request } from '@/api/request'

export type MessageKind = 'customer_reply' | 'agent_reply' | 'internal_note' | 'system_event'
export type ThreadViewMode = 'full' | 'customer' | 'notes'

export interface MessageAttachment {
  id: string
  fileName: string
  mimeType: string
  sizeBytes: number
  visibility: string
  uploadedAt: string
}

export interface MessageAuthor {
  kind: 'agent' | 'customer' | 'system'
  id: string | null
  name: string
  initials: string
  subtitle: string | null
}

/** One message of `GET /tickets/:id/messages` (chronological). */
export interface MessageView {
  id: string
  ticketId: string
  kind: MessageKind
  visibility: string
  channel: string | null
  body: string
  author: MessageAuthor
  mentions: string[]
  systemEventCode: string | null
  metadata: Record<string, unknown> | null
  createdAt: string
  edited: boolean
  attachments: MessageAttachment[]
}

export interface PostMessageInput {
  kind: 'customer_reply' | 'agent_reply' | 'internal_note' | 'system_event'
  body: string
  mentions?: string[]
  systemEventCode?: string
  customerVisible?: boolean
  metadata?: Record<string, unknown>
}

export interface PostMessageResult {
  message: MessageView
  ticketId: string
  followUp: { id: string; key: string } | null
  reopened: boolean
}

const enc = encodeURIComponent

export const messagesApi = {
  list: (ticketId: string, view: ThreadViewMode = 'full'): Promise<MessageView[]> =>
    request<MessageView[]>(`/tickets/${enc(ticketId)}/messages?view=${view}`),

  post: (ticketId: string, input: PostMessageInput): Promise<PostMessageResult> =>
    request<PostMessageResult>(`/tickets/${enc(ticketId)}/messages`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
}
